module.exports = __webpack_public_path__ + "img/4.932c17d2.jpg";